
import { Vue, Component, Prop } from "vue-property-decorator";

interface AccessInformationData {
    access_type: string;
    access_number: string;
    special_instructions: string;
}



@Component
export default class AccessInformation extends Vue {
  @Prop({ required: true }) readonly data!: AccessInformationData;
}
